import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7555e3da"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "company-profile"
};
const _hoisted_2 = {
  class: "top"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("  ");

const _hoisted_4 = {
  class: "img-boxs"
};
const _hoisted_5 = {
  class: "introduce center_1200"
};
const _hoisted_6 = {
  class: "tit"
};
const _hoisted_7 = {
  class: "txt"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, [_ctx.route.query.oldName ? (_openBlock(), _createElementBlock("b", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.goOnePath && _ctx.goOnePath(...args))
  }, _toDisplayString(_ctx.route.query.oldName) + "  > ", 1)) : _createCommentVNode("", true), _hoisted_3, _createElementVNode("b", null, _toDisplayString(_ctx.route.query.onlyName), 1)])]), _createElementVNode("h3", null, _toDisplayString(_ctx.route.query.onlyName), 1), _createElementVNode("h5", null, _toDisplayString(_ctx.route.query.subtitle), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
    src: _ctx.imgUrl(_ctx.companyData.coverUrl),
    lazy: "",
    fit: "cover"
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.companyData.name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, [_createElementVNode("span", null, [_createVNode(_component_el_image, {
    src: _ctx.imgUrl(_ctx.companyData.introduceFileUrl1),
    lazy: "",
    fit: "cover"
  }, null, 8, ["src"])]), _createElementVNode("div", {
    innerHTML: _ctx.companyData.introduce1
  }, null, 8, _hoisted_8)]), _ctx.companyData.displayType != '0' ? (_openBlock(), _createElementBlock("p", _hoisted_9, [_createElementVNode("span", null, [_createVNode(_component_el_image, {
    src: _ctx.imgUrl(_ctx.companyData.introduceFileUrl2),
    lazy: "",
    fit: "cover"
  }, null, 8, ["src"])]), _createElementVNode("div", {
    innerHTML: _ctx.companyData.introduce2
  }, null, 8, _hoisted_10)])) : _createCommentVNode("", true), _ctx.companyData.displayType == '2' ? (_openBlock(), _createElementBlock("p", _hoisted_11, [_createElementVNode("span", null, [_createVNode(_component_el_image, {
    src: _ctx.imgUrl(_ctx.companyData.introduceFileUrl3),
    lazy: "",
    fit: "cover"
  }, null, 8, ["src"])]), _createElementVNode("div", {
    innerHTML: _ctx.companyData.introduce3
  }, null, 8, _hoisted_12)])) : _createCommentVNode("", true)])])])]);
}